// extracted by mini-css-extract-plugin
module.exports = {"postHero":"PostHero-module--post-hero--2nXjO"};